export default "__VITE_ASSET__Bsf4BvQ2__"